/**
 * Constraint violation shape + severity semantics shared by the Plan Health
 * panel and the Override Policy modal (Doc 15 §2.4, Doc 17 §5).
 */

export interface ConstraintViolation {
  check_key: string;
  /** Engine-persisted violation rows (details.violations) omit result entirely. */
  result?: string;
  /** Engine writes numeric severity (0–1, Doc 15 §2.4); legacy rows used strings. */
  severity?: string | number;
  explanation?: string;
  remediation?: string;
}

/** Doc 15 §2.4 default severity threshold — mirrors severeViolationsPresent (planningQueries). */
export const SEVERE_THRESHOLD = 0.5;

export function isSevereViolation(v: ConstraintViolation): boolean {
  if (typeof v.severity === 'number') return v.severity >= SEVERE_THRESHOLD;
  return v.severity === 'fail' || v.severity === 'error' || v.result === 'fail';
}
